import 'src/styles/ui/checkbox.css';

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

const Checkbox = ({ id, label, checked, onChange, variant, disabled }) => {
  return (
    <label
      htmlFor={id}
      className={`checkbox checkbox--${variant} ${disabled ? 'checkbox--disabled' : ''}`}
    >
      <input
        id={id}
        type='checkbox'
        className='checkbox__input'
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className='checkbox__checkmark'>
        <FontAwesomeIcon className='checkbox__icon' icon={faCheck} />
      </span>
      {label}
    </label>
  );
};

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.node,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  variant: PropTypes.oneOf(['default', 'highlight']),
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  label: '',
  checked: false,
  onChange: () => {},
  variant: 'default',
};

export default Checkbox;
